import script from "./accordion.vue?vue&type=script&lang=js"
export * from "./accordion.vue?vue&type=script&lang=js"

import "./accordion.vue?vue&type=style&index=0&id=d099f944&lang=scss"

const __exports__ = script;

export default __exports__